import { render } from "./dataLoad.vue?vue&type=template&id=0b553db4&scoped=true&ts=true"
import script from "./dataLoad.vue?vue&type=script&lang=ts"
export * from "./dataLoad.vue?vue&type=script&lang=ts"

import "./dataLoad.vue?vue&type=style&index=0&id=0b553db4&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b553db4"]])

export default __exports__